/**
 * @generated SignedSource<<2af79e667a87f95a21276d6e9cd3daa7>>
 * @relayHash 817ce9c752f13f8f74204bb204ce3c90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7596a0697e5fcf3ab61f92e1338c5d7cf44aa3dfdab2a96cb7e01c642e7ee73e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type IssueNavigatorJiraGroupedListViewPaginationQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  fieldSetsScope?: JiraIssueSearchScope | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  id: string;
  isPaginating: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  saveJQLToUserHistory?: boolean | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
};
export type IssueNavigatorJiraGroupedListViewPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_jiraGroupedListViewData">;
  } | null | undefined;
};
export type IssueNavigatorJiraGroupedListViewPaginationQuery = {
  response: IssueNavigatorJiraGroupedListViewPaginationQuery$data;
  variables: IssueNavigatorJiraGroupedListViewPaginationQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": isGoalSmartLinkEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isGoalSmartLinkEnabled_provider from '@atlassian/jira-relay-provider/src/goal-group-header-smart-link.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isGroupByProjectsEnabled_provider from '@atlassian/jira-relay-provider/src/group-by-projects.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isJiraListReduceRerendersEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reduce-rerenders.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@atlassian/jira-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v16 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v20 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "groupBy",
    "variableName": "groupBy"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "saveJQLToUserHistory",
    "variableName": "saveJQLToUserHistory"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  (v19/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v22 = {
  "kind": "ScalarField",
  "name": "jql"
},
v23 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v24 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v25 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v28 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v29 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v30 = {
  "kind": "ScalarField",
  "name": "picture"
},
v31 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v32 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v31/*: any*/)
  ]
},
v33 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v18/*: any*/)
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "number"
},
v35 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v36 = {
  "kind": "ScalarField",
  "name": "value"
},
v37 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v18/*: any*/)
  ]
},
v38 = [
  (v18/*: any*/),
  {
    "kind": "ScalarField",
    "name": "sprintId"
  },
  (v26/*: any*/),
  {
    "kind": "ScalarField",
    "name": "state"
  },
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v39 = [
  (v26/*: any*/),
  (v37/*: any*/)
],
v40 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v41 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v42 = {
  "kind": "ScalarField",
  "name": "status"
},
v43 = {
  "kind": "ScalarField",
  "name": "key"
},
v44 = {
  "kind": "ScalarField",
  "name": "privateProject"
},
v45 = {
  "kind": "ScalarField",
  "name": "hasPermission"
},
v46 = {
  "kind": "ScalarField",
  "name": "iconName"
},
v47 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v49 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v50 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "kind": "ScalarField",
              "name": "priorityId"
            },
            (v26/*: any*/),
            (v27/*: any*/)
          ]
        },
        (v28/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v18/*: any*/),
            (v29/*: any*/),
            (v26/*: any*/),
            (v30/*: any*/)
          ]
        },
        (v28/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v26/*: any*/),
            (v32/*: any*/)
          ]
        },
        (v28/*: any*/),
        (v33/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v34/*: any*/)
      ],
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v35/*: any*/),
            (v36/*: any*/),
            (v37/*: any*/)
          ]
        },
        (v28/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v38/*: any*/)
        },
        (v28/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraLabel",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": (v39/*: any*/)
        }
      ],
      "type": "JiraJqlLabelFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v40/*: any*/),
            (v26/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGroupFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraVersion",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v41/*: any*/),
            (v26/*: any*/)
          ]
        },
        (v28/*: any*/)
      ],
      "type": "JiraJqlVersionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v28/*: any*/),
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v42/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            },
            (v18/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                (v43/*: any*/),
                (v26/*: any*/)
              ]
            }
          ]
        }
      ],
      "type": "JiraJqlGoalsFieldValue"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraTownsquareProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v43/*: any*/),
                (v44/*: any*/),
                (v45/*: any*/),
                (v26/*: any*/),
                (v46/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlTownsquareProjectFieldValue"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": true,
          "selections": [
            (v26/*: any*/),
            (v47/*: any*/),
            (v18/*: any*/),
            (v48/*: any*/),
            (v49/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlIssueTypeFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v28/*: any*/),
        {
          "concreteType": "JiraResolution",
          "kind": "LinkedField",
          "name": "resolution",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v26/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlResolutionFieldValue"
    }
  ]
},
v51 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v52 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v53 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v54 = {
  "kind": "ScalarField",
  "name": "message"
},
v55 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "fieldSetsScope"
  },
  (v19/*: any*/),
  {
    "kind": "Variable",
    "name": "viewConfigInput",
    "variableName": "viewConfigInput"
  }
],
v56 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v57 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v58 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v18/*: any*/)
  ]
},
v59 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v58/*: any*/),
    (v18/*: any*/)
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "__id"
},
v61 = {
  "kind": "ScalarField",
  "name": "type"
},
v62 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v63 = [
  (v36/*: any*/),
  (v18/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v64 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v65 = {
  "kind": "ClientExtension",
  "selections": [
    (v64/*: any*/)
  ]
},
v66 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v67 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v68 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v69 = {
  "kind": "ScalarField",
  "name": "date"
},
v70 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "text"
},
v72 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v74 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v75 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v76 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v77 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v78 = [
  (v18/*: any*/)
],
v79 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v78/*: any*/)
},
v80 = {
  "kind": "ClientExtension",
  "selections": [
    (v60/*: any*/)
  ]
},
v81 = {
  "kind": "ScalarField",
  "name": "href"
},
v82 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v83 = {
  "kind": "InlineFragment",
  "selections": [
    (v69/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v84 = [
  (v17/*: any*/),
  (v23/*: any*/),
  (v83/*: any*/),
  (v18/*: any*/)
],
v85 = [
  (v17/*: any*/),
  (v83/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v78/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
              },
              {
                "kind": "Variable",
                "name": "projectKeys",
                "variableName": "projectKeys"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "groups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ]
                      },
                      (v17/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v52/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      },
                      (v53/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "groupByField"
                  },
                  (v22/*: any*/),
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          }
                        ]
                      },
                      (v54/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPaginating",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "args": (v55/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v56/*: any*/),
                                      (v43/*: any*/),
                                      {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v49/*: any*/),
                                              (v18/*: any*/)
                                            ]
                                          },
                                          (v18/*: any*/)
                                        ]
                                      },
                                      (v57/*: any*/),
                                      (v59/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueTypeField",
                                            "kind": "LinkedField",
                                            "name": "issueTypeField",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          (v60/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "isHighlightedIssueRow"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 500
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSets",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v61/*: any*/),
                                              (v25/*: any*/),
                                              {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                  (v62/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v18/*: any*/),
                                                          (v17/*: any*/),
                                                          (v23/*: any*/),
                                                          (v61/*: any*/),
                                                          {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraIssueField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraAffectedServiceConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedAffectedServicesConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraAffectedService",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "serviceId"
                                                                          },
                                                                          (v26/*: any*/),
                                                                          (v18/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraAffectedServicesField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraCascadingOption",
                                                                "kind": "LinkedField",
                                                                "name": "cascadingOption",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOptionValue",
                                                                    "plural": false,
                                                                    "selections": (v63/*: any*/)
                                                                  },
                                                                  {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "childOptionValue",
                                                                    "plural": false,
                                                                    "selections": (v63/*: any*/)
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraCmdbObjectConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedCmdbObjectsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraCmdbObject",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "objectId"
                                                                          },
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "label"
                                                                          },
                                                                          {
                                                                            "concreteType": "JiraCmdbAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                                                "kind": "LinkedField",
                                                                                "name": "mediaClientConfig",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "clientId"
                                                                                  },
                                                                                  {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fileId"
                                                                                  },
                                                                                  {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaBaseUrl"
                                                                                  },
                                                                                  {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaJwtToken"
                                                                                  }
                                                                                ]
                                                                              },
                                                                              {
                                                                                "kind": "ScalarField",
                                                                                "name": "url48"
                                                                              }
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v54/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraCMDBField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "args": (v66/*: any*/),
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraComponentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraComponent",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v67/*: any*/),
                                                                          (v68/*: any*/),
                                                                          (v18/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraComponentsField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v69/*: any*/),
                                                              (v26/*: any*/),
                                                              (v70/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraDatePickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                              },
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraEpic",
                                                                "kind": "LinkedField",
                                                                "name": "epic",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v43/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                  },
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraEpicLinkField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "renderedFieldHtml"
                                                              }
                                                            ],
                                                            "type": "JiraFallbackField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v71/*: any*/),
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v31/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraStatusCategoryField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                  },
                                                                  (v33/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraStatusField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "args": (v66/*: any*/),
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v62/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraLabel",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": (v39/*: any*/)
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                              },
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraLabelsField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v47/*: any*/),
                                                                  (v26/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssue",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v43/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraColorField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueColorField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v37/*: any*/),
                                                                      (v18/*: any*/)
                                                                    ]
                                                                  },
                                                                  {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v72/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v18/*: any*/)
                                                                        ]
                                                                      },
                                                                      (v18/*: any*/)
                                                                    ]
                                                                  },
                                                                  {
                                                                    "concreteType": "JiraSingleLineTextField",
                                                                    "kind": "LinkedField",
                                                                    "name": "summaryField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v71/*: any*/),
                                                                      (v18/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v18/*: any*/),
                                                                  (v56/*: any*/),
                                                                  (v73/*: any*/),
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                      {
                                                                        "args": [
                                                                          {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                              "issuetype",
                                                                              "project",
                                                                              "summary",
                                                                              "status"
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldsById",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v17/*: any*/),
                                                                                  (v18/*: any*/),
                                                                                  {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                      (v23/*: any*/),
                                                                                      (v71/*: any*/)
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                  },
                                                                                  {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                      (v23/*: any*/),
                                                                                      {
                                                                                        "concreteType": "JiraIssueType",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "issueType",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v18/*: any*/),
                                                                                          (v48/*: any*/),
                                                                                          (v26/*: any*/),
                                                                                          (v72/*: any*/),
                                                                                          (v49/*: any*/)
                                                                                        ]
                                                                                      }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                  },
                                                                                  {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                      (v23/*: any*/),
                                                                                      {
                                                                                        "concreteType": "JiraStatus",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "status",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v18/*: any*/),
                                                                                          (v32/*: any*/)
                                                                                        ]
                                                                                      }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                  }
                                                                                ]
                                                                              }
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueTypeField",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypeField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v23/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v48/*: any*/),
                                                                              (v49/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      },
                                                                      {
                                                                        "concreteType": "JiraSingleLineTextField",
                                                                        "kind": "LinkedField",
                                                                        "name": "summaryField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v23/*: any*/)
                                                                        ]
                                                                      },
                                                                      {
                                                                        "concreteType": "JiraStatusField",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v23/*: any*/),
                                                                          (v58/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v27/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              },
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraPriorityField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v43/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "large"
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraProjectField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraResolution",
                                                                "kind": "LinkedField",
                                                                "name": "resolution",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraResolutionField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": (v38/*: any*/)
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v26/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraSprintField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v17/*: any*/),
                                                                  (v26/*: any*/),
                                                                  (v30/*: any*/),
                                                                  (v74/*: any*/),
                                                                  (v18/*: any*/),
                                                                  (v29/*: any*/),
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "TypeDiscriminator",
                                                                        "abstractKey": "__isUser"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": (v75/*: any*/),
                                                                        "type": "AppUser"
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": (v75/*: any*/)
                                                                      }
                                                                    ],
                                                                    "type": "AppUser"
                                                                  }
                                                                ]
                                                              },
                                                              (v70/*: any*/),
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraRichText",
                                                                "kind": "LinkedField",
                                                                "name": "richText",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraAdfToConvertedPlainText",
                                                                        "kind": "LinkedField",
                                                                        "name": "convertedPlainText",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "plainText"
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraRichTextField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraServiceManagementRequestType",
                                                                "kind": "LinkedField",
                                                                "name": "requestType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v72/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraServiceManagementRequestTypeField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "args": [
                                                                  {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                  }
                                                                ],
                                                                "concreteType": "JiraIssueLinkConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issueLinkConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v62/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueLink",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v73/*: any*/),
                                                                              (v43/*: any*/),
                                                                              {
                                                                                "args": [
                                                                                  {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                      "statusCategory"
                                                                                    ]
                                                                                  }
                                                                                ],
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldsById",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                      {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v17/*: any*/),
                                                                                          {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                              (v33/*: any*/)
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                          },
                                                                                          (v18/*: any*/)
                                                                                        ]
                                                                                      }
                                                                                    ]
                                                                                  }
                                                                                ],
                                                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                              },
                                                                              {
                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                  (v57/*: any*/)
                                                                                ]
                                                                              },
                                                                              (v18/*: any*/)
                                                                            ]
                                                                          },
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "relationName"
                                                                          },
                                                                          (v18/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "issueLinkConnection(first:1)"
                                                              }
                                                            ],
                                                            "type": "JiraIssueLinkField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "isStoryPointField"
                                                              },
                                                              (v34/*: any*/),
                                                              (v26/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "formatConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "formatStyle"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "formatUnit"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraNumberField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraCommentSummary",
                                                                "kind": "LinkedField",
                                                                "name": "commentSummary",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "canAddComment"
                                                                  },
                                                                  (v62/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "uri"
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraUrlField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v36/*: any*/),
                                                                  (v37/*: any*/),
                                                                  (v18/*: any*/),
                                                                  (v35/*: any*/)
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraOptionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v36/*: any*/),
                                                                          (v35/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraOptionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v36/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v17/*: any*/),
                                                                          (v29/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v30/*: any*/),
                                                                          (v18/*: any*/),
                                                                          (v74/*: any*/),
                                                                          {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                              {
                                                                                "kind": "ScalarField",
                                                                                "name": "email"
                                                                              }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraTeamView",
                                                                "kind": "LinkedField",
                                                                "name": "selectedTeam",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "jiraSuppliedId"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "jiraSuppliedName"
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraTimeTrackingField",
                                                                        "kind": "LinkedField",
                                                                        "name": "timeTrackingField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v76/*: any*/),
                                                                          (v77/*: any*/),
                                                                          (v23/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v61/*: any*/),
                                                                          (v65/*: any*/)
                                                                        ]
                                                                      },
                                                                      (v18/*: any*/)
                                                                    ]
                                                                  }
                                                                ],
                                                                "type": "JiraOriginalTimeEstimateField"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraTimeTrackingField",
                                                                        "kind": "LinkedField",
                                                                        "name": "timeTrackingField",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v76/*: any*/),
                                                                          (v77/*: any*/),
                                                                          (v18/*: any*/),
                                                                          (v23/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v61/*: any*/)
                                                                        ]
                                                                      },
                                                                      (v18/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v65/*: any*/)
                                                                ],
                                                                "type": "JiraOriginalTimeEstimateField"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                  },
                                                                  (v18/*: any*/),
                                                                  (v67/*: any*/)
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "args": (v66/*: any*/),
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v67/*: any*/),
                                                                          (v68/*: any*/),
                                                                          (v41/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              (v79/*: any*/),
                                                              {
                                                                "args": (v66/*: any*/),
                                                                "concreteType": "JiraGoalConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedGoals",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraGoal",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v43/*: any*/),
                                                                          {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                              (v26/*: any*/),
                                                                              (v42/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v80/*: any*/)
                                                                ],
                                                                "storageKey": "selectedGoals(first:1000)"
                                                              },
                                                              {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                  (v60/*: any*/),
                                                                  (v64/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  (v79/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "isLinkEditable"
                                                                  },
                                                                  {
                                                                    "concreteType": "JiraTownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      {
                                                                        "alias": "atlasProjectName",
                                                                        "kind": "ScalarField",
                                                                        "name": "name"
                                                                      },
                                                                      {
                                                                        "alias": "atlasProjectKey",
                                                                        "kind": "ScalarField",
                                                                        "name": "key"
                                                                      },
                                                                      (v44/*: any*/),
                                                                      (v45/*: any*/),
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "isWorkspaceActive"
                                                                      },
                                                                      (v46/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v65/*: any*/)
                                                                ],
                                                                "type": "JiraTownsquareProjectField"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "args": (v66/*: any*/),
                                                                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                "kind": "LinkedField",
                                                                "name": "confluenceRemoteIssueLinks",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v81/*: any*/),
                                                                          {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "name": "pageContent",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v17/*: any*/),
                                                                                  {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                      (v81/*: any*/)
                                                                                    ],
                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                  }
                                                                                ]
                                                                              }
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v62/*: any*/)
                                                                ],
                                                                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              {
                                                                "concreteType": "JiraGroupConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedGroupsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraGroupEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraGroup",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v26/*: any*/),
                                                                          (v40/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v65/*: any*/)
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraFlag",
                                                                "kind": "LinkedField",
                                                                "name": "flag",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFlagged"
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraFlagField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraWatch",
                                                                "kind": "LinkedField",
                                                                "name": "watch",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "count"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "isWatching"
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraWatchesField"
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v18/*: any*/),
                                                                          (v56/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraIssueTypeField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "concreteType": "JiraIssueType",
                                                                                "kind": "LinkedField",
                                                                                "name": "issueType",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v26/*: any*/),
                                                                                  (v49/*: any*/),
                                                                                  (v18/*: any*/)
                                                                                ]
                                                                              },
                                                                              (v18/*: any*/)
                                                                            ]
                                                                          },
                                                                          {
                                                                            "concreteType": "JiraParentIssueField",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentIssueField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "concreteType": "JiraIssue",
                                                                                "kind": "LinkedField",
                                                                                "name": "parentIssue",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v56/*: any*/),
                                                                                  (v43/*: any*/),
                                                                                  (v18/*: any*/)
                                                                                ]
                                                                              },
                                                                              (v18/*: any*/)
                                                                            ]
                                                                          },
                                                                          (v43/*: any*/),
                                                                          (v59/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "name": "user",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v17/*: any*/),
                                                                                  (v30/*: any*/),
                                                                                  (v18/*: any*/)
                                                                                ]
                                                                              },
                                                                              (v18/*: any*/)
                                                                            ]
                                                                          },
                                                                          {
                                                                            "args": (v82/*: any*/),
                                                                            "kind": "LinkedField",
                                                                            "name": "startDateViewField",
                                                                            "plural": false,
                                                                            "selections": (v84/*: any*/),
                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                          },
                                                                          {
                                                                            "args": (v82/*: any*/),
                                                                            "kind": "LinkedField",
                                                                            "name": "endDateViewField",
                                                                            "plural": false,
                                                                            "selections": (v84/*: any*/),
                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                          }
                                                                        ]
                                                                      },
                                                                      {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "name": "aggregatedStartDateViewField",
                                                                                "plural": false,
                                                                                "selections": (v85/*: any*/)
                                                                              },
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "name": "aggregatedEndDateViewField",
                                                                                "plural": false,
                                                                                "selections": (v85/*: any*/)
                                                                              }
                                                                            ],
                                                                            "type": "JiraAggregatedTimelineField"
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "type": "JiraTimelineVirtualField",
                                                                    "abstractKey": "__isJiraTimelineVirtualField"
                                                                  }
                                                                ],
                                                                "type": "JiraAggregatedTimelineField"
                                                              }
                                                            ]
                                                          },
                                                          (v80/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldSets(first:500)"
                                  },
                                  (v80/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v52/*: any*/),
                                  (v53/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "totalIssueSearchResultCount"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isCappingIssueSearchResult"
                              },
                              (v80/*: any*/)
                            ]
                          },
                          {
                            "args": (v55/*: any*/),
                            "filters": [
                              "viewConfigInput",
                              "fieldSetsInput",
                              "scope",
                              "settings"
                            ],
                            "handle": "connection",
                            "key": "firstGroupSection_nativeIssueTable__issues",
                            "kind": "LinkedHandle",
                            "name": "issues"
                          },
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v80/*: any*/)
                ]
              },
              {
                "args": (v20/*: any*/),
                "filters": [
                  "scope"
                ],
                "handle": "connection",
                "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                "kind": "LinkedHandle",
                "name": "groups"
              }
            ],
            "type": "JiraGroupedListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7596a0697e5fcf3ab61f92e1338c5d7cf44aa3dfdab2a96cb7e01c642e7ee73e",
    "metadata": {},
    "name": "IssueNavigatorJiraGroupedListViewPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider": isGoalSmartLinkEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider
    }
  }
};
})();

(node as any).hash = "4fa367a562859e9d187323c13ae08ba3";

export default node;
